module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/rc-align/~/core-js/library/modules/_fails.js
// module id = 146
// module chunks = 1